import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Header } from 'semantic-ui-react';
import CarouselArrow from './components/CarouselArrow';
import ImageGrid from './components/ImageGrid';
import IndicatorGroup from './components/IndicatorGroup';
import Carousel from '../../darkmatter/Carousel';
import { ImagesPropType } from '../../services/proptypes';
import './ImageCollection.css';
var ImageCollection = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageCollection, _React$Component);
  var _super = _createSuper(ImageCollection);
  function ImageCollection() {
    _classCallCheck(this, ImageCollection);
    return _super.apply(this, arguments);
  }
  _createClass(ImageCollection, [{
    key: "createImageRows",
    value: function createImageRows() {
      var _this$props = this.props,
        numberOfRowDisplayItems = _this$props.numberOfRowDisplayItems,
        images = _this$props.images,
        cutUnevenRows = _this$props.cutUnevenRows,
        smartImageGrouping = _this$props.smartImageGrouping;
      if (images.length < numberOfRowDisplayItems) {
        return [images];
      }
      var groupedImages = [];
      if (smartImageGrouping && images.length % numberOfRowDisplayItems !== 0) {
        // The last 2 rows will have less than numberOfRowDisplayItems
        // The idea is to have 2 rows divided evenly with numberOfRowDisplayItems
        // + (images.length % numberOfRowDisplayItems) images
        var remainingImages = numberOfRowDisplayItems + images.length % numberOfRowDisplayItems;
        var imagesToDivideInRowsEvenly = images.length - remainingImages;
        var idxOfSlice = imagesToDivideInRowsEvenly + Math.ceil(remainingImages / 2);
        groupedImages = ImageCollection.createChunks(images.slice(0, imagesToDivideInRowsEvenly), numberOfRowDisplayItems);
        return groupedImages.concat([images.slice(imagesToDivideInRowsEvenly, idxOfSlice)]).concat([images.slice(idxOfSlice)]);
      }
      return ImageCollection.createChunks(images, numberOfRowDisplayItems, cutUnevenRows);
    }
  }, {
    key: "renderCarousel",
    value: function renderCarousel() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
        images = _this$props2.images,
        numberOfRowDisplayItems = _this$props2.numberOfRowDisplayItems,
        disable = _this$props2.disable,
        carouselOptions = _this$props2.carouselOptions;
      var numberOfRowDisplayItemsOR = overrides.numberOfRowDisplayItemsOR,
        disableOR = overrides.disableOR;
      var finalDisable = disableOR || disable;
      var finalNumberOfRowDisplayItems = numberOfRowDisplayItemsOR || numberOfRowDisplayItems;
      var autoScroll = carouselOptions.autoScroll,
        autoScrollTime = carouselOptions.autoScrollTime;
      var imageLength = images.length;
      return /*#__PURE__*/React.createElement(Carousel, {
        totalNumberOfItems: images.length,
        autoScroll: autoScroll,
        autoScrollTime: autoScrollTime,
        numberOfDisplayItems: finalNumberOfRowDisplayItems > imageLength ? imageLength : finalNumberOfRowDisplayItems
      }, function (_ref) {
        var currentIndex = _ref.currentIndex,
          changeCurrentIndex = _ref.changeCurrentIndex,
          getDisplayItemIndices = _ref.getDisplayItemIndices;
        return /*#__PURE__*/React.createElement("div", {
          style: {
            margin: 'auto',
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement(ImageGrid, {
          imageGroups: [getDisplayItemIndices().map(function (index) {
            return images[index];
          })],
          rightArrow: finalDisable !== 'arrows' && finalDisable !== 'both' && /*#__PURE__*/React.createElement(CarouselArrow, {
            orientation: "right",
            onToggle: changeCurrentIndex,
            currentIndex: currentIndex
          }),
          leftArrow: finalDisable !== 'arrows' && finalDisable !== 'both' && /*#__PURE__*/React.createElement(CarouselArrow, {
            orientation: "left",
            onToggle: changeCurrentIndex,
            currentIndex: currentIndex
          })
        }), finalDisable !== 'indicators' && finalDisable !== 'both' && /*#__PURE__*/React.createElement(IndicatorGroup, {
          images: images,
          currentIndex: currentIndex,
          changeCurrentIndex: changeCurrentIndex
        }));
      });
    }
  }, {
    key: "renderGallery",
    value: function renderGallery() {
      var imageGroups = this.createImageRows();
      return /*#__PURE__*/React.createElement(ImageGrid, {
        imageGroups: imageGroups
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        images = _this$props3.images,
        as = _this$props3.as,
        centered = _this$props3.centered,
        header = _this$props3.header,
        className = _this$props3.className,
        ignoreMobileCarousel = _this$props3.ignoreMobileCarousel;
      var wrapperClassName = "imagecollection-wrapper ".concat(className);
      if (!images || !images.length) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClassName,
        style: centered ? {
          margin: 'auto',
          textAlign: 'center'
        } : {}
      }, header && /*#__PURE__*/React.createElement(Header, {
        as: "h1"
      }, header), /*#__PURE__*/React.createElement("span", {
        className: "imagecollection-desktop"
      }, as === 'gallery' ? this.renderGallery() : this.renderCarousel()), /*#__PURE__*/React.createElement("span", {
        className: "imagecollection-mobile"
      }, ignoreMobileCarousel ? this.renderGallery() : this.renderCarousel({
        numberOfRowDisplayItemsOR: 1,
        disable: 'none'
      })));
    }
  }], [{
    key: "createChunks",
    value: function createChunks(list, chunkSize) {
      var uniformChunks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var imageChunks = list.reduce(function (acc, _, i) {
        return i % chunkSize ? acc : [].concat(_toConsumableArray(acc), [list.slice(i, i + chunkSize)]);
      }, []);
      if (uniformChunks) {
        return imageChunks.filter(function (chunk) {
          return chunk.length === imageChunks[0].length;
        });
      }
      return imageChunks;
    }
  }]);
  return ImageCollection;
}(React.Component);
export { ImageCollection as default };
ImageCollection.defaultProps = {
  as: 'gallery',
  carouselOptions: {
    autoScroll: undefined,
    autoScrollTime: undefined
  },
  centered: false,
  className: '',
  cutUnevenRows: true,
  disable: 'none',
  header: '',
  numberOfRowDisplayItems: 3,
  ignoreMobileCarousel: false,
  smartImageGrouping: true
};
ImageCollection.propOptions = {};
ImageCollection.dataPropsMap = {
  images: ['business', 'gallery_images']
};